import { render, staticRenderFns } from "./ChangePageNameModal.vue?vue&type=template&id=92d1cbe8&scoped=true&"
import script from "./ChangePageNameModal.vue?vue&type=script&lang=ts&"
export * from "./ChangePageNameModal.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePageNameModal.vue?vue&type=style&index=0&id=92d1cbe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d1cbe8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardText,VCardTitle,VForm,VIcon,VSpacer})
